import React from 'react';

const SuccessModal = ({
  show,
  onClose,
  successMessage,
  paymentData,
  translations,
}) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
      }}
    >
      <div
        className="success_modal"
        style={{
          background: 'white',
          borderRadius: '12px',
          width: '100%',
          maxWidth: '500px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
          textAlign: 'center',
          position: 'relative',
        }}
      >
        <div
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: 'rgb(37, 99, 235)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0px auto 2px',
            boxShadow: '0 8px 20px rgba(16, 185, 129, 0.3)',
          }}
        >
          <div className="tick_success_icon">✓</div>
        </div>

        <h3 className="success_heading">
          {successMessage ? translations.success : translations.paymentSuccessful}
        </h3>

        <div className="success_message">
          {successMessage ||
            (paymentData?.message ===
            '🎉 Payment successful! You can now begin your domain assessment. 🚀'
              ? translations.paymentSuccessMessage
              : paymentData?.message) ||
            translations.paymentSuccessMessage}
        </div>

        <button
          onClick={onClose}
          className="continue_button"
          onMouseOver={(e) => {
            e.target.style.transform = 'translateY(-1px)';
            e.target.style.boxShadow = '0 6px 16px rgba(16, 185, 129, 0.4)';
          }}
          onMouseOut={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)';
          }}
        >
          {translations.continue}
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;
